import ValidatedField from "@/validation/ValidatedField";
import ValidatedForm from "@/validation/ValidatedForm";
import ApplicationUser from "@/server/com/silkplm/model/users/ApplicationUser";
import Rpc from "@/Rpc"
import Client from "@/utils/Client";
import {SILKPLM_DESIGNER, SILKPLM_FREE, SILKPLM_STANDARD, SUB_TYPE_ENTERPRISE} from "@/utils/SessionManager";

export default class DashboardUserForm extends ValidatedForm {
    constructor() {
        super();

        this.profileImage = new ValidatedField(this, null);

        this.email = new ValidatedField(this,"");
        this.phone = new ValidatedField(this,"", Rpc.Validators.validateShortOptionalText);
        this.password = new ValidatedField(this,"");
        this.password2 = new ValidatedField(this,"",
            (value) => value === this.password.value ? true : $tr('passwordsNeedToMatch','Passwords need to match'));
        this.login = new ValidatedField(this,"", async (val) => Rpc.Users.validateLogin(val, this.originalSource.id));
        this.firstName = new ValidatedField(this,"", Rpc.Validators.validateShortOptionalText);
        this.lastName = new ValidatedField(this,"", Rpc.Validators.validateShortOptionalText);
        this.initials = new ValidatedField(this,"", Rpc.Validators.validateShortOptionalText);

        this.integrationAccount = new ValidatedField(this,false);
        this.subscriptionType = new ValidatedField(this, SILKPLM_STANDARD);
        this.subscriptionTypeOptions = [];
        this.showSubType = false;

        this.password.validationFunction = async (value) => {
            if(this.mode === "NEW" || this.password.initialValue !== value) {
                 let res = await Rpc.Session.validatePassword(value);
                 this.password2.validate().then();
                 return res;
            }
            this.password2.validate().then();
        };
        this.email.validationFunction = async (value) => {
            if(this.mode === "NEW"){
                return await Rpc.Users.validateEmailForNewUser(value);
            }
            else
                return await Rpc.Users.validateEmailForUser(value, this.originalSource.id);
        };
        this.password.alwaysCheck = true;
        this.password2.alwaysCheck = true;
        this.setLabels();
    }

    async editUser(typeOfEditMode, userId) {
        this.password2.value = "";
        this.password.value = "";
        let user;
        if(typeOfEditMode === "EDIT_AS_USER")
            user = await Rpc.Users.getSessionUserInfo().lock();
        else
            user = await Rpc.Users.getSelectedUserInfo(userId).lock();
        super.editMode(user, typeOfEditMode);

        await this.setPlanOptions(user);
        await this.setPlanOptions(user);
        return user;
    }

    async setPlanOptions(user=null){
        if(SessionManager.userSubscriptionType === SILKPLM_FREE || SessionManager.organizationSubscriptionType === SUB_TYPE_ENTERPRISE){
            this.showSubType = false;
        } else {

            let slotsInfo = await Rpc.Subscriptions.slotsInfo();
            let availableSubsStandard = slotsInfo.availableStandard;
            let assignedSubsStandard = slotsInfo.assignedStandard;
            let availableSubsDesigner = slotsInfo.availableDesigner;
            let assignedSubsDesigner = slotsInfo.assignedDesigner;

            this.showSubType = true;
            let opts = [];
            let standardAvailable = availableSubsStandard > assignedSubsStandard;
            let designerAvailable = availableSubsDesigner > assignedSubsDesigner;


            if(user?.subscriptionType === SILKPLM_DESIGNER || designerAvailable){
                opts.push({
                    value: SILKPLM_DESIGNER,
                    text: "Designer"
                });
                this.subscriptionType.value = SILKPLM_DESIGNER;
            }
            if(user?.subscriptionType === SILKPLM_STANDARD || standardAvailable) {
                opts.push({
                        value: SILKPLM_STANDARD,
                        text: "Standard"
                    }
                );
                this.subscriptionType.value = SILKPLM_STANDARD;
            }

            if(user) {
                this.subscriptionType.value = user.subscriptionType;
            }

            this.subscriptionTypeOptions = opts;
        }
    }

    async saveUser(isEmailInvitationShouldBeSend){
        try {
            if (this.originalSource.id != null) {
                this.populateValuesTo(this.originalSource);
                if (this.mode === "EDIT_AS_ADMIN")
                    return await Rpc.Users.editExistingUser(this.originalSource, this.password.value).lock();
                else if (this.mode === "EDIT_AS_USER")
                    return await Rpc.Users.editMyAccount(this.originalSource, this.password.value).lock();
            }
            let user = this.populateValuesTo(this.originalSource);
            user = await Rpc.Users.addUser(user, this.password.value, isEmailInvitationShouldBeSend).lock();
            this.populateValuesTo(user);
            return user;
        }
        catch(e) {
            this.parseException(e);
        }
    }

    async refresh(){
        let user = await Rpc.Users.getSessionUserInfo();
        super.fillValuesFrom(user);
    }

    newUser(){
        this.originalSource = new ApplicationUser();
        super.createMode(this.originalSource);
    }

}